import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

const heigthColumns = 40
const contentMaxWidth = '100%'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    width: contentMaxWidth,
    overflowX: 'auto',
    margin: '1rem 0',
    borderRadius: '8px',
    border: '1px solid #E0E0E0',
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
  },

  center: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
  },

  table: {
    width: '100%',
    borderCollapse: 'collapse',
  },

  thead: {
    backgroundColor: '#f5f5f5',
  },

  head: {
    height: heigthColumns,
  },

  th: {
    padding: '2rem 1.5rem 1rem 1.5rem',
    fontWeight: 'bold',
    fontSize: '14px',
    borderBottom: '1px solid #E0E0E0',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '200px',
  },

  tbody: {
    textAlign: 'left',
  },

  body: {
    height: heigthColumns,
    borderBottom: '1px solid #E0E0E0',
  },

  td: {
    padding: '1rem 2rem',
    fontSize: '14px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '200px',
  },

  ellipsis: {
    display: 'inline-block',
    maxWidth: '100%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },

  paginationContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: '1rem',
    width: '100%',
    gap: '1rem',
  },

  rowsPerPage: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
  },

  pageInfo: {
    flexShrink: 0,
  },

  navigationButtons: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
  },

  button: {
    minWidth: '2rem',
    minHeight: '2rem',
    padding: '0.5rem',
  },

  select: {
    border: '1px solid #E0E0E0',
    borderRadius: '4px',
    padding: '0.25rem 0.5rem',
  },
}))

export { useStyles }
